module.exports = __webpack_public_path__ + "img/anchor.6d2b24f4.svg";